import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { createSettings, SettingsDTO } from 'src/app/interfaces/settings';
import { SettingsService } from 'src/app/services/settings.service';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-welcome-dialog',
  imports: [MatDialogClose, FormsModule],
  templateUrl: './welcome-dialog.component.html',
  styleUrl: './welcome-dialog.component.scss'
})
export class WelcomeDialogComponent implements OnInit {

  showOnboarding: boolean = true;
  envClass = 'prod';
  settings: SettingsDTO = { id: -1, userId: -1, timeZone: '', outlookHours: 0, lookbackHours: 0, keepDoneVisible: 0, revisionsEnabled: false, showOnHold: false, taskNotificationsEnabled: false,
    taskNotificationTime: '9:00', meetingNotificationsEnabled: false, meetingNotificationLeadTime: 0, showWelcomePopup: true };

  constructor(public dialogRef: MatDialogRef<WelcomeDialogComponent>, private settingsService: SettingsService) {

  }

  ngOnInit() {
    this.envClass = `env-${environment.name}`;
    this.getSettings();
  }

  async getSettings() {
    this.settings = await firstValueFrom(this.settingsService.getSettings());
  }

  async onShowWelcomePopup(event: Event) {
    this.settings = await firstValueFrom(this.settingsService.saveSettings(this.settings.id, createSettings(this.settings.userId, this.settings.timeZone, 
      this.settings.outlookHours, this.settings.lookbackHours, this.settings.keepDoneVisible, this.settings.revisionsEnabled, this.settings.showOnHold, 
      this.settings.taskNotificationsEnabled, this.settings.taskNotificationTime, this.settings.meetingNotificationsEnabled, this.settings.meetingNotificationLeadTime, this.settings.showWelcomePopup)));
  }
}
